<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex my-4 pl-4 title align-center justify-center>{{ title }}</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="ACCOUNT.REGISTER">
            <v-btn large color="error" @click="$emit('add')">DODAJ OPERATORA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        role-link-field="officialRoles"
        entity-type="profile"
        :headers="headers"
        :actions="actions"
        :items="users"
        :total-count="count"
        v-on="$listeners"
        @roles="goToRoles"
      />
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { DELETE_ACTION, DETAILS_ACTION, EDIT_ACTION, ROLES_ACTION } from '@/utils/actions';
import { UserState } from '@witkac/kartamiejska-shared';

const accountStateTranslation = {
  [UserState.NOT_CONFIRMED]: 'Niepotwierdzone',
  [UserState.DISABLED]: 'Wyłączone',
  [UserState.ACTIVE]: 'Aktywne'
};

/**
 * @vuese
 * @group Officials
 * Lista operatorów
 */

export default {
  components: {
    MaterialTable,
    MaterialCard,
    Search
  },
  props: {
    // Tytuł strony
    title: String,
    // Lista operatorów
    users: Array,
    // Całkowita liczba operatorów
    count: Number
    // Link do szczegółów
  },
  data() {
    return {
      headers: [
        { value: 'user.login', sortable: false, text: 'Login', link: true, render: profile => profile.user.login },
        { value: 'email', orderBy: ['email', 'id'], text: 'Email', link: true },
        { value: 'firstName', orderBy: ['firstName', 'lastName', 'id'], text: 'Imię' },
        { value: 'lastName', orderBy: ['lastName', 'firstName', 'id'], text: 'Nazwisko' },
        {
          value: 'user.state',
          text: 'Status konta',
          sortable: false,
          render: profile => accountStateTranslation[profile.user.state]
        }
      ],
      actions: [DELETE_ACTION, EDIT_ACTION, ROLES_ACTION, DETAILS_ACTION]
    };
  },
  methods: {
    goToRoles(profile) {
      this.$router.push({ name: 'officialRoles', params: { id: profile.userId } });
    }
  }
};
</script>
